// 播放时间、前一句、后一句
export const CHANGE_AUDIO_TIME = 'audio:changeTime';
// 播放、暂停
export const CHANGE_AUDIO_PLAY = 'audio:changePlay';
export const CHANGE_AUDIO_PAUSE = 'audio:changePause';
// 音量
export const CHANGE_AUDIO_VOLUME = 'audio:changeVolume';
// 静音
export const CHANGE_AUDIO_MUTED = 'audio:changeMuted';
// 倍速
export const CHANGE_AUDIO_SPEED = 'audio:changeSpeed';
// 跳过空白帧
export const CHANGE_AUDIO_SKIPBLANK = 'audio:changeSkipBlank';
// 章节速览高亮
export const CHANGE_AUDIO_HLTMARKSEGINDEX = 'audio:changeHltMarkSegIndex';
